import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { Cookies } from '../index.js';
function ToggleButton(props) {
  const { onToggle } = props;
  const { isOnload } = props;
  const { newbie_buff } = props;
  const [isOn, setIsOn] = useState(false);

  const { thaydoi } = props;
  function handleClick() {
    setIsOn(prevIsOn => !prevIsOn);
    onToggle && onToggle(!isOn); // gọi hàm onToggle và truyền giá trị của isOn
  }
  useEffect(() => {
    if (isOnload == 'no' || !isOnload) {
      setIsOn(false);
    }
    else {
      if (newbie_buff == 'NO') {
        setIsOn(false);
      }
      else {
        setIsOn(true);
      }
    }
  }, [isOnload]);


  return (
    <button
      className={classNames(
        'w-12 h-6 rounded-full shadow-inner',
        { 'bg-pink-500': isOn, 'bg-gray-400': !isOn }
      )}
      onClick={handleClick}
    >
      <span className="sr-only">{isOn ? 'On' : 'Off'}</span>
      <span
        className={classNames(
          'block w-4 h-4 rounded-full transition-all duration-200 ease-in-out',
          { 'bg-white': !isOn, 'bg-pink-200': isOn, 'translate-x-1': !isOn, 'translate-x-7': isOn }
        )}
        style={{
          left: isOn ? 'calc(100% - 14px)' : '2px',
          boxShadow: isOn ? '0 0 0 2px rgba(234, 103, 152, 0.7)' : ''
        }}
      />
    </button>
  );
}

export default ToggleButton;
